export default function getFilteredModifiers(modifiers) {
  const findOption = option => option.availabilityAt && option.availabilityAt.available
  const findModifier = modifier => modifier.options && !!modifier.options.find(findOption)
  return modifiers.map((modifier, index) => ({...modifier, index})).filter(findModifier)
}
